<template>
    <div>
        <div class="col-md-8 mx-auto p-4">
            <!--            <h5 style="font-size: 12pt" class="btn btn-block btn-grad text-center text-white">{{ this.pageName }}</h5>-->
            <p class="pt-3" v-if="this.breadcrumb.length === 0 && this.edit === false">دسته آگهی مورد نظر خود را انتخاب
                کنید.</p>
            <a class="btn btn-link text-decoration-none text-dark mb-2"
               v-if="this.breadcrumb.length >= 1 && showCategory" @click="backCategory()">
                بازگشت به دسته اصلی
                <i class="fa fa-arrow-left text-dark mx-2"></i>
            </a>

            <nav aria-label="breadcrumb" class="breads mx-5 mt-5" v-if="breadcrumb.length > 0" @click="loadCategory()">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item mx-2" aria-current="page" v-for="item in breadcrumb">{{ item }}</li>
                </ol>
            </nav>

            <ul v-if="showCategory" style="list-style: none" class="py-5">
                <input type="hidden" required name="category" id="category" :value="current" @change="getCurrent">
                <li style="font-size: 11pt;" class="cursor-pointer py-2 px-5"
                    v-for="item in category.filter((x) => x.parentSlug === current)" @click="changeCategory(item)">
                    <i v-for="x in catIcons.filter(y => y.slug === item.slug)" :class="x.icon"
                       style="margin: 0 1rem;font-size: 14pt;color: #3F51B5"></i>
                    <i :class="'kt-icon kt-icon-' + item.slug + ' kt-icon--lg kt-base-row__icon'"
                       v-if="item.parentSlug === 'root'"></i>
                    {{ item.title }}
                    <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>
                </li>
                <li @click="changeCategory(category.find((x) => x.slug === current))" style="font-size: 11pt;"
                    class="cursor-pointer py-2 px-5" v-if="breadcrumb.length >=1">
                    متفرقه
                    <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>


import {Bus} from "../../../../main";

export default {
    name: "categorySelector",
    props: {
        auto_changes: {
            default: false,
            require: true
        },
        phone: {
            default: undefined,
        },
        multiAdsCat: {
            type: Boolean,
            default: true
        },
        pageName: {
            type: String,
            default: 'ثبت آگهی'
        },
        edit: {
            type: Boolean,
            default: false
        },
        edit_def: {
            type: Boolean,
            default: false
        },
        editCategory: {
            type: String,
            default: 'real-estate'
        },
        gradual: {
            type: Boolean,
            default: false
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            before: [],
            extraField: [],
            breadcrumb: [],
            showCategory: true,
            queryString: new URLSearchParams(),
            current: 'real-estate',
            Rp: [],
            timer: null,
            cityReq: '',
            category: [],
            singleFiltered: {
                "contact": null,
                "zoonkan_enabled": null,
                "category": null,
                "location": null,
                "optional_fields_description_section": null,
                "other_options_and_attributes": null,
                "images": null,
                "hide_phone": null,
                "chat_enabled": null,
                "phone": null,
                "user_type": null,
                "force_chat_enabled": null
            },
            multiFiltered: {
                "force_chat_enabled": null,
                "title": null,
                "user_type": null,
                "description": null,
                "hide_phone": null,
                "chat_enabled": null,
                "phone": null,
                "new_price": null,
                "contact": null,
                "zoonkan_enabled": null,
                "category": null,
                "location": null,
                "optional_fields_description_section": null,
                "images": null,
                "other_options_and_attributes": null,
                "colored_parts": null,
            },
            catIcons: [
                {icon: "fa fa-home", slug: "real-estate"},
                {icon: "fa fa-car", slug: "vehicles"},
                {icon: "fa fa-desktop", slug: "electronic-devices"},
                {icon: "fa fa-lightbulb", slug: "home-kitchen"},
                {icon: "fa fa-wrench", slug: "services"},
                {icon: "fa fa-user", slug: "personal"},
                {icon: "fa fa-dice", slug: "leisure-hobbies"},
                {icon: "fa fa-users", slug: "community"},
                {icon: "fa fa-industry", slug: "tools-materials-equipment"},
                {icon: "fa fa-briefcase", slug: "jobs"},
            ],
            forNational: []
        }
    },
    methods: {
        findSource(currentSlug) {
            if (currentSlug === 'real-estate') {
                this.before.push('real-estate');
                this.breadcrumb.reverse();
                this.before.reverse();
                this.before.pop();
                this.current = this.editCategory
                this.getFields(this.editCategory)
                return 'real-estate';
            }
            if (this.edit || this.edit_def) {
                const result = this.category.find((x) => x.slug === currentSlug);
                this.breadcrumb.push(result.title);
                this.before.push(result.slug);
                return this.findSource(result.parentSlug);
            }
        },
        loadCategory() {
            if (this.$data.showCategory)
                return;

            this.$data.showCategory = true;
            this.$data.current = this.$data.before.pop();
            this.$data.breadcrumb.pop();
        },
        backCategory: function () {
            if (this.before.length <= 0)
                return;

            this.current = this.before.pop();
            this.breadcrumb.pop();
        },
        changeCategory: function (item) {
            let search = this.category.filter(x => x.parentSlug === item.slug);

            if (search.length === 0 || this.current === item.slug) {
                this.showCategory = false;
                this.getFields(item.slug)
            }

            this.before.push(this.current);
            this.current = item.slug;
            this.breadcrumb.push(item.title);
        },
        getFields: function (slug, breadcrumb = true) {
            const vue = this;
            this.$data.showCategory = false;
            if (breadcrumb)
                $.ajax(
                    {
                        url: `${url}/user/divar/dependency/${slug}?` + vue.queryString.toString(),
                        type: 'POST',
                        dataType: 'json',
                        fn: this.getFields,
                        headers: {
                            'Authorization': Token,
                            "Accept": "application/json"

                        },
                        success: function (data) {
                            if (vue.multiAdsCat)
                                vue.fields = data.data.filter((x) => {
                                    if (Object.keys(vue.multiFiltered).includes(x.name)) {
                                        vue.multiFiltered[x.name] = true;
                                        return false;
                                    }
                                    return true;
                                });
                            else {
                                vue.fields = data.data.filter((x) => {
                                    if (Object.keys(vue.singleFiltered).includes(x.name)) {
                                        vue.singleFiltered[x.name] = true;
                                        return false;
                                    }
                                    return true;
                                });
                                if (vue.fields.find((x) => x.title === 'سایر ویژگی‌ها')) {
                                    const start = vue.fields.indexOf(vue.fields.find((x) => x.title === 'سایر ویژگی‌ها'));
                                    const end = vue.fields.indexOf(vue.fields.find((x) => x.title === 'عنوان آگهی'));
                                    vue.extraField = vue.fields.splice(start, end - start);
                                    Bus.setProp("category_fields", vue.fields)
                                }
                            }
                        }
                    }
                );
        },
        generateQueryString(key, value) {
            this.queryString.delete(key);
            this.queryString.append(key, value);
            this.getFields(this.current, false);
        },
        getCategories() {
            const vue = this;
            $.ajax(
                {
                    url: `${url}/user/divar/categories`,
                    type: "GET",
                    fn: this.getCategories,
                    dataType: "json",
                    headers: {
                        "ACCEPT": "application/json",
                        Authorization: Token
                    },
                    success: (data) => {
                        vue.category = data.data;
                        if (this.edit)
                            this.findSource(this.editCategory);
                    }
                }
            )
        },
        Buses() {
            Bus.$emit('category-multi-filtered', this.multiFiltered);
            Bus.$emit('category-single-filtered', this.singleFiltered);
        },
        debounce(fn, timout = 1000) {
            clearTimeout(this.timer);
            this.timer = setTimeout(fn, timout);
        },
        getCurrent() {
            if (this.gradual === true) {
                this.getFields(this.current)
                this.debounce(function () {
                    Bus.$emit('category-current', this.current)
                }, 500)
            } else
                return false;
        }
    },
    watch: {
        fields: function () {
            this.$emit('category-fields', this.fields);
            this.Buses();
        },
        extraField: {
            handler: function () {
                Bus.$emit('other_attrs', this.extraField);
                this.Buses();
            },
            deep: true
        },
        current: {
            handler: function (value) {
                this.debounce(() => {
                    Bus.setProp("category_current", value);
                    Bus.$emit('category-current', value);
                }, 4000)
            },
            deep: true
        },
        auto_changes: function (value) {
            if (value === true) {
                this.getFields(this.current)
                this.debounce(function () {
                    Bus.$emit('category-current', this.current)
                }, 500)
            } else
                return false;
        },
        forNational: function (value) {
            Bus.$emit('national', !!value.find((x) => x.name === "national_id"));
        },
        phone(val) {
            const vue = this;
            if (vue.current !== 'root') {
                const mine = $.ajax(
                    {
                        url: `${url}/divar/categories/${this.current}/dependency` + vue.queryString.toString(),
                        type: 'POST',
                        dataType: 'json',
                        fn: this.mine,
                        headers: {
                            'Authorization': Token,
                            "Accept": "application/json",
                            "Content-Type": 'application/json'
                        },
                        data: JSON.stringify({
                            "contact": {
                                "phone": this.phone || undefined
                            },
                            "location": {
                                "city": this.cityReq
                            },
                            "category": this.current,
                            "images": [],
                        }),
                        success: function (data) {
                            if (vue.multiAdsCat)
                                vue.fields = data.data.filter((x) => {
                                    if (Object.keys(vue.multiFiltered).includes(x.name)) {
                                        vue.multiFiltered[x.name] = true;
                                        return false;
                                    }
                                    return true;
                                });
                            else
                                vue.fields = data.data.filter((x) => {
                                    if (Object.keys(vue.singleFiltered).includes(x.name)) {
                                        vue.singleFiltered[x.name] = true;
                                        return false;
                                    }
                                    return true;
                                });
                            vue.forNational = vue.fields;
                            Bus.setProp("category_fields", vue.fields);
                        }
                    }
                );
            }
        }
    },
    beforeMount() {
        this.getCategories();
    },
    mounted() {

        Bus.$on('cityInfo', (value) => {
            this.cityReq = value.city
        });

        Bus.$on('selected_numbers', (value) => {
            this.phone = value
        });

        Bus.$on('getBreadCrumb', () => {
            this.before = [];
            this.breadcrumb = [];
            this.findSource(this.editCategory)
        });
    }
}
</script>

<style scoped>

</style>